import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {apiQuery, getUrl} from "../../utils/api-config";
import {Response} from "../../types/response/Response";
import {InfoCreateDTO, InfoDTO, InfoEditDTO} from "../../types/utils/InfoDTO";
import {DeleteParams} from "../../types/utils/Constants";

export const measurementApi = createApi({
    reducerPath: "measurement",
    baseQuery: apiQuery,
    tagTypes: ["measurements"],
    endpoints: builder => ({
        getMeasurement: builder.query<Response<InfoDTO[]>, Partial<number | undefined>>({
            query: (accountId) => getUrl('/measurements', [{name: "account_id", value: accountId}]),
            providesTags: ['measurements']
        }),
        createMeasurement: builder.mutation <void, Partial<InfoCreateDTO>>({
            query: (body) => ({
                url: "/measurements",
                method: "POST",
                body
            }),
            invalidatesTags: ["measurements"]
        }),
        editMeasurement: builder.mutation <void, Partial<InfoEditDTO>>({
            query: (body) => ({
                url: `/measurements/${body.id}`,
                method: "PATCH",
                body
            }),
            invalidatesTags: ["measurements"]
        }),
        deleteMeasurement: builder.mutation <void, Partial<DeleteParams>>({
            query: (params) => ({
                url: getUrl(`/measurements/${params.id}`, [{name: "account_id", value: params.accountId}]),
                method: "DELETE"
            }),
            invalidatesTags: ["measurements"]
        }),
    })
})

export const {useGetMeasurementQuery, useCreateMeasurementMutation,useEditMeasurementMutation,useDeleteMeasurementMutation} = measurementApi
